/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $,once) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";
      $(once("main-menu-process", ".header.simple-menu")).each(function () {
        $(".menu_second_level__wrapper").addClass("ready");

        $(document).on('click', "#block-ocg-main-menu #main-nav> .main-menu.level-0> .main-menu__item--with-sub", function () {
          if($(window).width() >= 1024) {
            var $this = $(this);
            $this.siblings().removeClass('is-open');
            $this.toggleClass("is-open");
          }
        });

        $('#block-ocg-main-menu #main-nav> .main-menu.level-0> .main-menu__item--with-sub').on('click', function(){
          if($(window).width() >= 1024) {
            var $this = $(this);
            $this.siblings().removeClass('is-open');
            $this.toggleClass("is-open");
          }
        })


        $(document).mouseup(function(e) {
          if($(window).width() >= 1024) {
            var container = $("#block-ocg-main-menu .main-menu.level-0> .main-menu__item--with-sub.is-open");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.find(e.target).length === 0) {
              container.removeClass('is-open');
            }
          }
        });

        //top menu desktop
        $("#block-topmenu .main-menu__link.main-menu__link--with-sub").on(
          "click",
          function () {
            var $this = $(this);
            $this.parent().siblings().removeClass('top-menu-open');
            $this.parent().toggleClass("top-menu-open");
          }
        );

        setTimeout(() => {
          $("#block-topmenu .menu_second_level__wrapper").show();
        }, 300);

        $(document).mouseup(function(e) {
          var container = $("#block-topmenu .main-menu__link.main-menu__link--with-sub");
          if (!container.is(e.target) && container.find(e.target).length === 0) {
            container.parent().removeClass('top-menu-open');
          }
      });

      //adding top menu to header mobile
      var addTopMenu = function() {
        if($('.toggle-expand__wrapper #main-nav').children().length == 1) {
          var wrapper = $('.toggle-expand__wrapper #main-nav');
          wrapper.prepend('<div class="menu-area">Home</div>');
          wrapper.append('<div class="menu-area">Corporate information</div>');
          wrapper.append($('#block-topmenu').children().clone().addClass('top-menu-clone'));
          wrapper.append($('.print-page').clone().addClass('print-page-mobile'));
          wrapper.append($('#block-menubutton').children().clone().addClass('mobile-menu-buttons'));
          wrapper.find('.print-page-mobile a').text('Print this page');
        }
      }

      var removeTopMenu = function() {
        if($('.toggle-expand__wrapper #main-nav').children().length > 1) {
          $('.toggle-expand__wrapper #main-nav').children('.menu-area, .top-menu-clone, .mobile-menu-buttons').remove();
        }
      }

      if($(window).width() < 1024) {
        addTopMenu();
      }

        $(".main-menu__item--with-sub:not(.is-open)").on("click", function (e) {
          e.stopPropagation();
          var $this = $(this);

          if($(window).width() < 1024) {

            if($this.parents('.main-menu__item').hasClass('is-open')) {
              $this.parents('.main-menu__item').addClass('sub-is-open').children('.main-menu__link, .expand-sub').slideUp(300);
            } else {
              $this.closest('.main-menu.level-0').siblings().slideUp(300);
            }

            $('.menu-controls__title').addClass('menu-deeper-levels');

            $this.addClass("is-open");
            var childList = $this.find('.menu_item_list').first();
            var childListHeighit = childList.show().height();
            childList.hide();

            $(".header.simple-menu .toggle-expand__wrapper").animate({
              height: childListHeighit+40+52+55
            },300);

            $this.siblings().slideUp(300);

            setTimeout( function() {
              childList.show();
              childList.children().hide();

              childList.children().each(function(index) {
                $(this).delay(75*index).fadeIn(300);
              });
            }, 300);


            // if ($this.children(".menu_second_level__wrapper").length) {
            //   $(this)
            //     .siblings(".menu_second_level__wrapper")
            //     .find(".menu_item_list")
            //     .first()
            //     .stop()
            //     .slideToggle(300);
            // } else {
            //   $(this).siblings(".menu_item_list").stop().slideToggle(300);
            // }
          }
        });

        $(once('menu-control-process','.menu-controls__title-back')).on('click', function(){
          var currentOpenItem = $('.main-menu__item.main-menu__item--with-sub.is-open:not(.sub-is-open)');

          if(currentOpenItem.closest('.sub-is-open').length) {
            var parentLevel = currentOpenItem.closest('.sub-is-open');
            currentOpenItem.removeClass('is-open').find('.menu_item_list').first().slideUp(300);
            parentLevel.removeClass('sub-is-open');
            parentLevel.children('.main-menu__link, .expand-sub').slideDown(300);

            var childList = parentLevel.find('.menu_item_list').first();
            childList.children().show();
            var childListHeighit = childList.show().height();
            var currHeight = currentOpenItem.height();
            childList.hide();

            $(".header.simple-menu .toggle-expand__wrapper").animate({
              height: childListHeighit-currHeight+40+40+52+55
            },300);

            currentOpenItem.siblings().slideUp(300);

            setTimeout( function() {
              childList.show();
              childList.children().hide();
              childList.children().each(function(index) {
                $(this).delay(75*index).fadeIn(300);
              });
            }, 300);
          }
          else {
            $('.menu-controls__title').removeClass('menu-deeper-levels');
            var parentListHeight = (1 + currentOpenItem.siblings().length) * 52;
            var childrenHeight = currentOpenItem.find('.menu_item_list').height();
            var totalHeight = 0;
            $('#main-nav').children().show();
            $("#main-nav").children().each(function(){
              totalHeight = totalHeight + $(this).outerHeight(true);
            });
            $('#main-nav').children().hide();
            $('#main-nav').children().fadeIn(300);

            currentOpenItem.closest('.main-menu.level-0').siblings().slideDown(300);
            currentOpenItem.removeClass('is-open').find('.menu_item_list').first().slideUp(300);
            currentOpenItem.siblings().fadeIn(300);

            $(".header.simple-menu .toggle-expand__wrapper").animate({
              height: totalHeight-childrenHeight+parentListHeight+44
            },300);
          }
        })

        $('.menu-close__icon').on('click', function(){
          closeMobileMenu();
        })

        var closeMobileMenu = function() {
          $(".header.simple-menu .toggle-expand__wrapper").stop().slideUp(400);
        }

        if (!$(".header #main-nav >.top-menu-links").length) {
          $("#block-topmenulinks .menu.level-0")
            .clone()
            .addClass("top-menu-links")
            .appendTo($(".header #main-nav"));
        }

        $(".hamburger-menu__wrapper").on("click", function () {
          $('#ocg-google-search').stop().slideUp(300);
          $(this).toggleClass("active");

          $(".mobile-logo").toggleClass("header-open");
          $(".header.simple-menu .toggle-expand__wrapper")
            .stop()
            .slideToggle(400);
        });

        // //search
        // $(".search-control").on("click", function () {
        //   $(this).toggleClass("search-open");
        //   if (window.matchMedia("(max-width: " + 1023 + "px)").matches) {
        //     $(".hamburger-menu__wrapper").toggle();
        //   } else {
        //     $(this)
        //       .parent()
        //       .siblings(".toggle-expand__wrapper")
        //       .toggleClass("fade-out");
        //   }

        //   $(this)
        //     .siblings("form")
        //     .find("input.form-search.form-item__textfield")
        //     .get(0)
        //     .focus();
        // });

        // search desktop
        let isSearchOpen = false;
        $('.search-wrapper .search-icon').on('click', function(){

          if($(window).width() < 1024) {
            closeMobileMenu();

            // if(!$(this).siblings('#ocg-google-search').children('.search-close__icon').length) {
            //   $(this).siblings('#ocg-google-search').append('<div class="search-close__icon"></div>');
            // }
            $(this).siblings('#ocg-google-search').width($('body').innerWidth()).stop().slideToggle(300, function(e) {
              if(!isSearchOpen) {
                isSearchOpen = true;
                $('.search-wrapper .search-icon .search-icon__label').text('Close');
              } else {
                isSearchOpen = false;
                $('.search-wrapper .search-icon .search-icon__label').text('Search');
              }
            });
            setTimeout(() => {
              // $(this).siblings('#ocg-google-search').find('input[type="search"]').get(0).focus();
              $('#ocg-google-search .gsc-input').focus();
            }, 500);
            // $('.search-close__icon').on('click', function(){
            //   $('#ocg-google-search').stop().slideUp(300).find('input[type="search"]').val('');
            // })
          }
          else {
            $(this).parent().addClass('search-open');
            $(this).siblings('#ocg-google-search').show();
            setTimeout(() => {
              // $(this).siblings('#ocg-google-search').find('input[type="search"]').get(0).focus();
              $('#ocg-google-search .gsc-input').focus();
            }, 500);

            $(document).mouseup(function(e) {
              var container = $(".search-wrapper");
              if (!container.is(e.target) && container.find(e.target).length === 0) {
                container.removeClass('search-open');
                setTimeout(() => {
                  container.children('#ocg-google-search').hide().find('input[type="search"]').val('');
                }, 300);
              }
            });
          }
        })

        //menu items 2 line break
        var resizeMenuItems = function(ready){
          if($('body').innerWidth() >=1024) {
            $('#block-ocg-main-menu #main-nav>.main-menu.level-0>.main-menu__item:not(.resized)').each(function(){

              var $this = $(this).children('.main-menu__link');

              var maxWidth = Math.round($this[0].getBoundingClientRect().width);

              var words = $this.text().split(' ');

              var wordCount = words.length;

              while($this[0].getBoundingClientRect().height<=36 && wordCount > 1 && !$('body.site-ndiswc').length) {
                maxWidth--;
                $this.css('max-width', maxWidth + 'px');
              }

              if(ready) {
                $this.css('max-width', (maxWidth + 10) + 'px');
              } else {
                $this.css('max-width', (maxWidth + 16) + 'px');
              }

              if(ready) {
                $(this).css({
                  "opacity": "1",
                  "visibility": "visible",
                  "padding": "17px 16px",
                });

                //fixing multiple calls when logged in
                $(this).addClass('resized');
                setTimeout(() => {
                  $(this).removeClass('resized');
                }, 500);
              }
            })
          }
          else {
            $('#block-ocg-main-menu #main-nav>.main-menu.level-0>.main-menu__item').css('max-width','100%');
          }
        }

        $.fn.overflown=function(){var e=this[0];return e.scrollHeight>e.clientHeight||e.scrollWidth>e.clientWidth;}
        var resizeMegaMenu = function(resize) {
          if($('body').innerWidth() >=1024) {

              $('#block-ocg-main-menu #main-nav .menu_second_level__wrapper').each(function(){
                var megaMenu = $(this).children().children('.menu_item_list.menu_second_level');

                if(resize) {
                  megaMenu.css('max-height', '200px');
                }
                var currHeight = megaMenu.height();
                var idealHeight = 1000;
                var incrHeight = currHeight;


                while(incrHeight<1000) {
                  if(megaMenu.children('.main-menu__item.quick-links').length) {
                    megaMenu.children('.main-menu__item.quick-links').height(idealHeight-40);
                  }

                  if(currHeight < idealHeight && !(megaMenu.overflown())) {
                    idealHeight = currHeight;
                  }

                  incrHeight+=8;

                  megaMenu.css('max-height', incrHeight + 'px');
                  currHeight = megaMenu.height();
                }

                megaMenu.css('max-height', idealHeight+22 + 'px');
              })
         }
        }
        resizeMenuItems();
        resizeMegaMenu();

        setTimeout(() => {
          resizeMenuItems(true);
          resizeMegaMenu();
        }, 150);

        setTimeout(() => {
          resizeMegaMenu(true);
        }, 1000);

        var resizeTimer;
        $(window).on('resize', function(e) {

          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            resizeMenuItems(true);
            resizeMegaMenu(true);

            if($(window).width() < 1024) {
              addTopMenu();
              $('#ocg-google-search').width($('body').innerWidth());
            }
            else {
              removeTopMenu();
            }
          }, 250);
        });

        $('.rate-widget.thumbsupdown').show().prependTo('footer>.region-footer');
        $( document ).ajaxComplete(function() {
          $('.rating-table').find('label.form-type-radio.rate-voted').parent().addClass('is-active');
        });

        //hiding related content
        $('main.has-sidebar .paragraph-related-content__content.status-2 .card-list .card__wrapper:nth-child(3)').remove();

        //scroll to top
        $(once('page-scroll-top-process','.page-scroll-top__content')).on('click', function(){
          $("html, body").stop().scrollTop(0);
        })
      }); // once
    },
  };
})(Drupal, jQuery,once);
